import { MarketplaceServiceRecommendationBanner } from './marketplace-service-recommendation-banner';
import { useMarketplaceServiceRecommendation } from './use-marketplace-service-recommendation';

const MarketplaceServiceRecommendation = () => {
  const marketplaceRecommendation = useMarketplaceServiceRecommendation();
  if (!marketplaceRecommendation) {
    return null;
  }

  return (
    <MarketplaceServiceRecommendationBanner
      marketplaceId={marketplaceRecommendation.marketplaceId}
      recommendedShippingService={marketplaceRecommendation.recommendedShippingService}
    />
  );
};

export default MarketplaceServiceRecommendation;
